import * as React from "react";
const SvgVisibilityInvisible20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "m16.254 5.16 3.453-3.453L18.293.293l-18 18 1.414 1.414 3.638-3.638C6.647 16.9 8.207 17.5 10 17.5c3.16 0 5.595-1.863 7.172-3.572a17.321 17.321 0 0 0 2.3-3.16 10.305 10.305 0 0 0 .158-.292l.01-.02.002-.005.002-.003.224-.448-.224-.448-.002-.003-.002-.006-.01-.018-.021-.04-.013-.025a15.645 15.645 0 0 0-.598-1.015 17.316 17.316 0 0 0-1.826-2.373c-.28-.303-.586-.61-.918-.912Zm-1.416 1.416-1.759 1.759a3.5 3.5 0 0 1-4.744 4.744l-1.533 1.533c.956.54 2.027.888 3.198.888 2.34 0 4.28-1.387 5.703-2.928A15.314 15.314 0 0 0 17.607 10a15.316 15.316 0 0 0-1.904-2.572c-.27-.292-.559-.579-.865-.852Zm-4.921 4.922L10 11.5a1.5 1.5 0 0 0 1.498-1.583l-1.582 1.58Zm9.727-1.946L18.75 10l.894-.448ZM18.75 10l.894.448L18.75 10ZM10 2.5c1.03 0 1.983.198 2.855.524l-1.609 1.608A5.958 5.958 0 0 0 10 4.5c-2.34 0-4.28 1.387-5.703 2.928A15.315 15.315 0 0 0 2.393 10a15.63 15.63 0 0 0 1.441 2.044l-1.419 1.42a17.583 17.583 0 0 1-1.887-2.696 10.34 10.34 0 0 1-.158-.292l-.01-.02-.003-.005v-.002s-.002-.002.893-.449l-.894-.448.001-.003.003-.006.01-.018a6.438 6.438 0 0 1 .158-.293 17.314 17.314 0 0 1 2.3-3.16C4.405 4.363 6.84 2.5 10 2.5ZM.356 9.552 1.25 10l-.895.447L.132 10l.224-.448ZM9.31 6.568A3.504 3.504 0 0 0 6.568 9.31L9.31 6.568Z",
      clipRule: "evenodd"
    })
  );
export default SvgVisibilityInvisible20Px;
